<template>
  <button :class="propClass" @click="doAction()">
    <i v-if="propIcon" :class="propIcon"></i>
    <span>{{ propLabel }}</span>
  </button>
</template>
<script>
export default {
  name: 'Button',
  emits: ['callback'],
  props: ['type','icon','label','className'],
  data: function () {
    return {
      propLabel: "",
      propClass: "",
      propIcon: "",
      buttonTypes: {
        custom: {
          label: "",
          class: "bt",
          icon: "",
          callback: ""
        },
        create: {
          label: "créer",
          class: "bt bt-create",
          icon: "icon icon-plus",
          callback: "create"
        },
        import: {
          label: "importer",
          class: "bt bt-import",
          icon: "icon icon-import",
          callback: "importFile"
        },
        export: {
          label: "Export xls",
          class: "bt bt-export",
          icon: "icon icon-export",
          callback:  "exportFile"
        }
      }
    }
  },
  methods: {
    doAction() {
      if (this.$listeners.hasOwnProperty("callback")) {
        this.$emit('callback');
      } else  {
        let propCallback = this.buttonTypes[this.type].callback
        this.$parent[propCallback](this.propFileName)
      }
    }
  },
  created: function() {
   let type = this.type || "custom"
    this.propLabel = this.label || this.buttonTypes[type].label || null
    this.propClass = this.className || this.buttonTypes[type].class || null
    this.propIcon = this.icon || this.buttonTypes[type].icon || null
    // this.propCallback = this.callback || this.buttonTypes[this.type].callback
    this.propFileName = this.fileName || this.buttonTypes[type].fileName || null
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Button.vue